export { CellDetails } from "./CellDetails";
